import angular from 'angular';
import components from './components';

export default angular.module('importantDocuments.scenes', [components]).name;
